import { writable } from 'svelte/store';

export const weatherStore = writable(0);